/** Shared form validators for lab order requisition forms. */

/** Validates MM/DD/YYYY date strings. Returns error message or null. */
export function validateDate(v: string): string | null {
  if (!v) return null
  const match = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (!match) return 'Use MM/DD/YYYY format'
  const [, mm, dd, yyyy] = match
  const month = Number(mm)
  const day = Number(dd)
  const year = Number(yyyy)
  const date = new Date(year, month - 1, day)
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day)
    return 'Invalid date'
  return null
}

/** Validates HH:MM time strings (12-hour). Returns error message or null. */
export function validateTime(v: string): string | null {
  if (!v) return null
  const match = v.match(/^(\d{1,2}):(\d{2})$/)
  if (!match) return 'Use HH:MM format'
  const hour = Number(match[1])
  const min = Number(match[2])
  if (hour < 1 || hour > 12) return 'Hour must be 1–12'
  if (min < 0 || min > 59) return 'Minutes must be 00–59'
  return null
}

/** Validates a phone number has at least 10 digits. Returns error message or null. */
export function validatePhone(v: string, label = 'Phone'): string | null {
  if (v && v.replace(/\D/g, '').length < 10) return `${label} must have at least 10 digits`
  return null
}

/**
 * Parses a "City, ST ZIP" string into parts.
 * Handles formats like "North Miami Beach, FL 33160".
 */
export function parseCityStateZip(combined: string): {
  city: string
  state: string
  zip: string
} {
  if (!combined) return { city: '', state: '', zip: '' }
  // Try "City, ST ZIP" pattern
  const match = combined.match(/^(.+?),\s*([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)$/)
  if (match) return { city: match[1].trim(), state: match[2], zip: match[3] }
  // Fallback — return whole string as city
  return { city: combined, state: '', zip: '' }
}

/** Reconstructs a "City, ST ZIP" string from parts. */
export function buildCityStateZip(city: string, state: string, zip: string): string {
  const parts = [city, state && zip ? `${state} ${zip}` : state || zip].filter(Boolean)
  return parts.join(', ')
}
